import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider, Theme } from '@mui/material/styles';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from "@mui/material/FormControlLabel";
import Modal from '@mui/material/Modal';

import STRINGS from './Terms';

const theme = createTheme();

interface IUser {
  email: string,
  firstName: string,
  lastName: string,
  phoneNumber: string,
  password: string,
}


const useStyles = makeStyles((theme: Theme) => ({
  bottomSpacing: {
    marginBottom: 40 //MRG_BOTT.bottomSpacing,
  },
  terminos: {
    marginBottom: 40,
    marginTop: 5,
    fontSize: 20
  },
  modal: {
    position:'absolute',
    top:'5%',
    left:'5%',
    width: '90%',
    background: "white",
    border: "2px solid #000",
    boxShadow: '24',
    padding: "16px 32px 24px",
    transform: "tranlate(-50%, -50%)",
    // overflowY: 'scroll',
    height: '80%',
    display: 'block'
  },
  content: {
      padding: 12,
    
  },
  spacing: {
      marginBottom:56
  },
  divide: {
    width: '100%',
    height: '380px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    overflowY: 'scroll',
    borderBottom: '2px solid #cfc9c9',
    padding: '15px',
  }
}));

function TermsCond(checked: boolean, handleChange: (check: boolean) => void) {
  
  const styles = useStyles()

  const [modal, setModal] = useState(false)
  
  const abrircerrarmodal = () => {
    setModal(!modal)
  }
  
  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event.target.checked)
  }

  const body = (
      <>
      <div className={styles.modal}>
          <div className={styles.divide}>
            {STRINGS.SECTIONS.map(({TITLE, CONTENT}, idx) => (
              <div key={idx} className={styles.spacing}>
                  <Typography variant='h6' gutterBottom>{TITLE}</Typography>
                  {CONTENT.map((content, idx) => 
                    <Typography key={idx} component='span' paragraph>{parse(content)}</Typography>
                  )}
              </div>
            ))}
          </div>
      
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} style={{marginTop: '20px'}}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={checked}
                        onChange={handleChange2}
                        name="terminos"
                    />
                    }
                    label="He leído y acepto los términos y condiciones."
                />

                <Button 
                    onClick={()=>abrircerrarmodal()}
                    variant="contained" 
                    style={{marginLeft: '15px', backgroundColor: '#0C7BDD', color: '#FFFFFF'}}
                >Continuar</Button>
            </Grid>
          </Grid>
      </div>
      </>
  )

  return (
      <div>
          <Button 
              onClick={()=>abrircerrarmodal()}
              variant="contained" 
              style={{backgroundColor: '#0C7BDD', color: '#FFFFFF'}}
          >Terminos y Condiciones</Button>
          <Modal
            disableEscapeKeyDown
            open={modal}
            onClose={(event, reason) => {
              if(reason !== 'backdropClick') {
                  abrircerrarmodal()
              }
            }}
          >
              {body}
          </Modal>
      </div>
  )
}

export default function SignUp() {
  const classes = useStyles()
  const [terms_cond, setTerms_cond] = useState(false)

  const [ errFields, setErrFields ] = useState<IUser>({
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
  })

  const [errStatus, setErrStatus] = useState({
    email: false,
    firstName: false,
    lastName: false,
    phoneNumber: false,
    password: false,
  })

    let navegate = useNavigate();

    const { search } = useLocation()
    const query = new URLSearchParams(search)
    let ref = query.get("Ref")
    if(!ref) {
      ref = window.localStorage.getItem("Sponsor")
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        // eslint-disable-next-line no-console
        const data = {
            email: form.get('email'),
            nombre: form.get('firstName'),
            apellidos: form.get('lastName'),
            celular: form.get('phoneNumber'),
            password: form.get('password'),
            id_ref: form.get(''),
        }

        if(!data.nombre) {
          setErrFields({ ...errFields, firstName: "Este es un campo obligatorio" })
          setErrStatus({ ...errStatus, firstName: true })
          return
        }

        if(!data.apellidos) {
          setErrFields({ ...errFields, lastName: "Este es un campo obligatorio" })
          setErrStatus({ ...errStatus, lastName: true })
          return
        }

        if(!data.celular) {
          setErrFields({ ...errFields, phoneNumber: "Este es un campo obligatorio" })
          setErrStatus({ ...errStatus, phoneNumber: true })
          return
        }

        if(!data.email) {
          setErrFields({ ...errFields, email: "Este es un campo obligatorio" })
          setErrStatus({ ...errStatus, email: true })
          return
        }

        if(!data.password) {
          setErrFields({ ...errFields, password: "Este es un campo obligatorio" })
          setErrStatus({ ...errStatus, password: true })
          return
        }

        try {
            const result = await axios.post('/api/veirify-email/', { "email": form.get('email') })
            const data = await result.data
            const idUser = data.idUser
            if(idUser > 0) {
              navegate(`/inicio`)
              alert(`Usuario ya existe con el email = ${form.get('email')}`)
              return
            }
        } catch( ex ) {
            console.log("Error: Query no permitido.  Favor ver Log del Servidor.")
        }

        try {
            data.id_ref = ref
            console.log(data)
            await axios.post('/api/user/', data)
            navegate(`/inicio`)
        } catch( ex ) {
            console.log("Error: Query no permitido.  Favor ver Log del Servidor.")
        }
    };

  const validField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, n: number): void => {

    if(e.target.value.length > 0 && e.target.value.length < n) {
      setErrStatus({ ...errStatus, [e.target.name]: true })
      setErrFields({ ...errFields, [e.target.name]: `Campo debe tener mínimo ${n} caracteres` })
    } else {
      setErrStatus({ ...errStatus, [e.target.name]: false })
      setErrFields({ ...errFields, [e.target.name]: ""} )
    }
  }

  const validEmail = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

    if (!emailRegex.test(e.target.value)) {
      setErrStatus({ ...errStatus, [e.target.name]: true })
      setErrFields({ ...errFields, [e.target.name]: `Debe indicar un nombre Email Válido.` })
    } else {
      setErrStatus({ ...errStatus, [e.target.name]: false })
      setErrFields({ ...errFields, [e.target.name]: ""} )
    }
  }

  const validPhone = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const emailRegex = /[0-9]{4}-[0-9]{4}/;

    if (!emailRegex.test(e.target.value)) {
      setErrStatus({ ...errStatus, [e.target.name]: true })
      setErrFields({ ...errFields, [e.target.name]: `Debe indicar número de célular ####-####.` })
    } else {
      setErrStatus({ ...errStatus, [e.target.name]: false })
      setErrFields({ ...errFields, [e.target.name]: ""} )
    }
  }

  const handleChange = (check: boolean) => {
    setTerms_cond(check)
  }

  const body = TermsCond(terms_cond, handleChange)

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

          <Typography component="h1" variant="h5">
            Nuevo
          </Typography>
          <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="Nombre"
                  autoFocus
                  autoComplete="family-name"
                  error={ errStatus.firstName }
                  onChange={ (e) => validField(e, 3) }
                  helperText={ errFields.firstName }
                  />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="lastName"
                  required
                  fullWidth
                  id="lastName"
                  label="Apellidos"
                  autoComplete="family-name"
                  error={ errStatus.lastName }
                  onChange={ (e) => validField(e, 3) }
                  helperText={ errFields.lastName }
                  />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="phoneNumber"
                  label="Celular"
                  name="phoneNumber"
                  error={ errStatus.phoneNumber }
                  onChange={ (e) => validPhone(e) }
                  helperText={ errFields.phoneNumber }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  type="email"
                  name="email"
                  onChange={ (e) => validEmail(e) }
                  error={ errStatus.email }
                  helperText={ errFields.email }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="Password"
                  error={ errStatus.password }
                  onChange={ (e) => validField(e, 6) }
                  helperText={ errFields.password }
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={!terms_cond}
            >
              Resgistro
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link to="/inicio" >
                  Ya tienes una Cuenta? 
                  <Typography>
                    Iniciar Sesión
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12} classes={{item: classes.terminos}}>
                {body}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}